<template>
    <b-alert v-if="error_message" variant="danger" show>
      {{ error_message }}
    </b-alert>
  </template>

<script>
export default {
  props: {
    error_message: {
      type: String,
      required: true,
    },
  },
};
</script>
